import React, {useCallback} from 'react';
import {ArrowUp} from '../icons/ArrowUp';
import {Button} from '../buttons/Button';
import styled from 'styled-components';
import {lighten, darken} from '@material-ui/core/styles/colorManipulator';

import root from 'window-or-global';
import {subNavHeight} from './Subnav.config';

const BackToTop = styled.div`
    display: inline-block;
    ${(p) => p.theme.breakpoints.up('lg')} {
        position: absolute;
        top: 0;
        left: 0;
    }

    span.label {
        transition: color 0.2s ${(p) => p.theme.easing};
    }

    &&& {
        &.arrow-only {
            position: fixed;
            left: 0;
            background-color: ${(p) =>
                p.theme.ifLight(
                    p,
                    p.theme.palette.neutral.chalk,
                    p.theme.palette.neutral.concrete
                )};
            button.secondary {
                width: ${subNavHeight}px;
                .ue-icon-arrow-up {
                    margin: 0;
                }
            }
        }

        button.secondary {
            height: ${subNavHeight}px;
            padding: 0 ${(p) => `${p.theme.spacing(1)}px`};
            ${(p) => p.theme.breakpoints.up('lg')} {
                padding: 0 ${(p) => `${p.theme.spacing(2)}px`};
            }
            ${(p) => p.theme.breakpoints.up('xxl')} {
                padding: 0 ${(p) => `${p.theme.spacing(3)}px`};
            }
            @media (min-width: 1280px) and (max-width: 1400px) {
                padding: 0 ${(p) => `${p.theme.spacing(1)}px`};
            }
            min-height: ${subNavHeight}px;
            min-width: auto;
            border-radius: 0;
            .container {
                .button {
                    display: flex;
                    font-family: ${(p) => p.theme.fonts.brutal.medium};
                    font-size: 11px;
                    line-height: 16px;
                }
            }
            border: none;
            border-right: 1px solid
                ${(p) =>
                    p.theme.ifLight(
                        p,
                        darken(p.theme.palette.neutral.chalk, 0.1),
                        lighten(p.theme.palette.neutral.concrete, 0.1)
                    )};

            &:hover {
                span.label {
                    color: ${(p) => p.theme.palette.text.primary};
                }
                box-shadow: initial;
                border-image-source: initial;
                border-right: 1px solid
                    ${(p) =>
                        p.theme.ifLight(
                            p,
                            darken(p.theme.palette.neutral.chalk, 0.1),
                            lighten(p.theme.palette.neutral.concrete, 0.1)
                        )};
                .ue-icon-arrow-up {
                    transform: translateY(-2px);
                }
            }

            .ue-icon-arrow-up {
                transition: 0.3s ${(p) => p.theme.easing};
                font-size: 17px;
                margin-right: ${(p) => `${p.theme.spacing(1)}px`};
                color: ${(p) =>
                    p.theme.ifLight(
                        p,
                        'theme.palette.neutral.steel',
                        'theme.palette.neutral.stone'
                    )};
            }
        }
    }
`;

export interface SubnavBackToTopBtnProps {
    label?: string;
    arrowOnly?: boolean;
}

export const SubnavBackToTopBtn = ({
    label = 'Back to top',
    arrowOnly = false
}: SubnavBackToTopBtnProps): JSX.Element => {
    const onClick = useCallback((e) => {
        root.scrollTo({top: 0, left: 0, behavior: 'smooth'});
        e.preventDefault();
    }, []);

    return (
        <BackToTop className={`top-btn ${arrowOnly ? 'arrow-only' : ''}`}>
            <Button type="secondary" onClick={onClick}>
                <ArrowUp fontSize="inherit" />
                {!arrowOnly && <span className="label">{label}</span>}
            </Button>
        </BackToTop>
    );
};
